export const SET_TIER_PARTICIPANTS = '@tier/set-participants';
export const APPLY_TIER_PARTICIPANTS = '@tier/apply-participants';
export const DEDUCT_TIER_PARTICIPANTS = '@tier/deduct-participants';
export const RESET_TIER_PARTICIPANTS = '@tier/reset-participants';

export const INTEGRATE_SESSION_PARTICIPANTS = '@tier/set-session-participants';

export const TIER_PARTICIPANTS = 'tierParticipantsDropdown';
